// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2j331","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__9goAW"};